var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.1 49.1"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.55 49.1A24.55 24.55 0 1149.1 24.55 24.55 24.55 0 0124.55 49.1m0-45.38a20.83 20.83 0 1020.83 20.83A20.85 20.85 0 0024.55 3.72m-1.27 3v16.37H10v2.54h15.82V6.68z",
    fill: "#999",
    "data-name": "Layer 1"
  }))));
}
export default SvgDuration;